export default __webpack_public_path__ + "static/media/logo branca.1766d2c6.png";